package com.futurions.portfolio.components

import androidx.compose.runtime.*

import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Canvas
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import kotlin.math.*
import kotlin.random.Random

@Composable
fun AnimatedNetworkBackground() {
    Canvas(
        attrs = {
            id("networkCanvas")
            style {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("width", "100vw")
                property("height", "100vh")
                property("z-index", "-1")
                property("background", "linear-gradient(180deg, #050505 0%, #000000 100%)")
                property("overflow", "hidden")
            }
        }
    )

    LaunchedEffect(Unit) {
        val canvas = document.getElementById("networkCanvas") as HTMLCanvasElement
        val ctx = canvas.getContext("2d") as CanvasRenderingContext2D

        fun resizeCanvas() {
            canvas.width = window.innerWidth
            canvas.height = window.innerHeight
        }

        resizeCanvas()
        window.onresize = { resizeCanvas() }

        data class Node(
            var x: Double,
            var y: Double,
            var dx: Double,
            var dy: Double
        )

        val nodeCount = 80
        val nodes = List(nodeCount) {
            Node(
                x = Random.nextDouble(canvas.width.toDouble()),
                y = Random.nextDouble(canvas.height.toDouble()),
                dx = Random.nextDouble(-0.5, 0.5),
                dy = Random.nextDouble(-0.5, 0.5)
            )
        }

        fun animate() {
            ctx.fillStyle = "rgba(0, 0, 0, 0.1)"
            ctx.fillRect(0.0, 0.0, canvas.width.toDouble(), canvas.height.toDouble())

            for (node in nodes) {
                // Move nodes
                node.x += node.dx
                node.y += node.dy

                if (node.x < 0 || node.x > canvas.width) node.dx *= -1
                if (node.y < 0 || node.y > canvas.height) node.dy *= -1

                // Draw node glow
                ctx.beginPath()
                val gradient = ctx.createRadialGradient(node.x, node.y, 0.0, node.x, node.y, 6.0)
                gradient.addColorStop(0.0, "rgba(0, 200, 255, 0.9)")
                gradient.addColorStop(1.0, "rgba(0, 200, 255, 0)")
                ctx.fillStyle = gradient
                ctx.arc(node.x, node.y, 3.0, 0.0, 2 * PI)
                ctx.fill()
            }

            // Draw connecting lines
            for (i in 0 until nodes.size) {
                for (j in i + 1 until nodes.size) {
                    val dx = nodes[i].x - nodes[j].x
                    val dy = nodes[i].y - nodes[j].y
                    val distance = sqrt(dx * dx + dy * dy)
                    if (distance < 150) {
                        val opacity = 1 - (distance / 150)
                        ctx.beginPath()
                        ctx.strokeStyle = "rgba(0, 200, 255, $opacity)"
                        ctx.lineWidth = 0.7
                        ctx.moveTo(nodes[i].x, nodes[i].y)
                        ctx.lineTo(nodes[j].x, nodes[j].y)
                        ctx.stroke()
                    }
                }
            }

            window.requestAnimationFrame { animate() }
        }

        animate()
    }
}
